import { ObjectMeta } from "../../common";
import { z } from "zod";
export const DesignElementOrigin = z.object({
    id: z.string(),
    sourceId: z.string(),
    name: z.string(),
});
export const DesignElementBase = z.object({
    id: z.string(),
    persistentId: z.string(),
    meta: ObjectMeta,
    designSystemVersionId: z.string(),
    createdAt: z.coerce.date(),
    updatedAt: z.coerce.date(),
});
export const DesignElementImportedBase = DesignElementBase.extend({
    origin: DesignElementOrigin,
});
export const DesignElementGroupablePart = z.object({
    parentPersistentId: z.string().optional(),
    sortOrder: z.number(),
});
export const DesignElementGroupableBase = DesignElementBase.extend(DesignElementGroupablePart.shape);
export const DesignElementGroupableRequiredPart = DesignElementGroupablePart.extend({
    parentPersistentId: z.string(),
});
export const DesignElementBrandedPart = z.object({
    brandPersistentId: z.string(),
});
export const DesignElementSlugPart = z.object({
    slug: z.string().optional(),
    userSlug: z.string().optional(),
});
